// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// Lodash
import { each } from 'lodash-es';
// CRUD
import { QueryResultsModel } from '../../_base/crud';
// State
import { AllergiesState } from '../_reducers/allergy.reducers';
import { Allergy } from '../_models/allergy.model';

export const selectAllergiesState = createFeatureSelector<AllergiesState>('allergies');

export const selectAllergyById = (contactRelationshipId: number) =>
  createSelector(selectAllergiesState, (allergiesState) => {
    return allergiesState.entities[contactRelationshipId];
  });

export const selectAllergiesPageLoading = createSelector(
  selectAllergiesState,
  (allergiesState) => allergiesState.loading,
);

export const selectCurrentEntityIdInStoreForAllergy = createSelector(
  selectAllergiesState,
  (allergiesState) => allergiesState.entityId,
);

export const selectAllergiesWaitingMessage = createSelector(
  selectAllergiesState,
  (allergiesState) => allergiesState.showInitWaitingMessage,
);

export const selectAllergiesActionLoading = createSelector(
  selectAllergiesState,
  (allergiesState) => allergiesState.actionsloading,
);

export const selectAllergyErrorState = createSelector(
  selectAllergiesState,
  (allergyState) => allergyState.error,
);

export const selectAllergiesInStore = createSelector(selectAllergiesState, (allergiesState) => {
  const items: Allergy[] = [];
  each(allergiesState.entities, (element) => {
    items.push(element);
  });
  return new QueryResultsModel(items, allergiesState.totalCount);
});
